<template>
    <div class="create-ask-box">
        <div id="view"></div>
        <van-nav-bar title=" " left-text="返回" left-arrow @click-left="onClickLeft" placeholder fixed :z-index="2" />
        <div class="form-box">
            <van-form label-width="7em" ref="formRef" scroll-to-error @submit.prevent colon>
                <div class="user-info-box form-step-box" v-watermark>
                    <div class="user-title">基本信息</div>
                    <template v-if="disabled">
                        <van-cell title="患者类型" :value="addEditData.isMainland ? '非中国大陆患者' : '中国大陆患者'" />
                        <van-cell title="姓名" :value="addEditData.name" />
                        <van-cell :title="addEditData.isMainland ? '有效证件号' : '身份证'" :value="addEditData.idCard" />
                        <template v-if="addEditData.isMainland">
                            <van-cell title="性别" :value="{ 1: '男', 0: '女' }[addEditData.sex] || '未知'" />
                            <van-cell title="出生日期" :value="addEditData.birthday" />
                        </template>
                    </template>
                    <template v-else>
                        <van-field name="isMainland" label="患者类型" input-align="right">
                            <template #input>
                                <van-checkbox shape="square" v-model="addEditData.isMainland">非中国大陆患者</van-checkbox>
                            </template>
                        </van-field>
                        <van-field v-model="addEditData.name" name="name" label="姓名" input-align="right">
                        </van-field>
                        <van-field :value="addEditData.idCard" name="idCard"
                            :label="addEditData.isMainland ? '有效证件号' : '身份证'" input-align="right" @input="onIdCardInput">
                        </van-field>
                        <template v-if="addEditData.isMainland">
                            <van-field name="sex" label="性别" input-align="right">
                                <template #input>
                                    <van-radio-group v-model="addEditData.sex" direction="horizontal">
                                        <van-radio :name="item.id"
                                            v-for="item in [{ name: '男', id: 1 }, { name: '女', id: 0 }]" :key="item.id">
                                            {{ item.name }}
                                        </van-radio>
                                    </van-radio-group>
                                </template>
                            </van-field>
                            <van-field v-model="addEditData.birthday" name="birthday" label="出生日期" input-align="right">
                                <template #input>
                                    <div @click="onShowPopup('birthday')">
                                        <span>
                                            {{ addEditData.birthday || '请选择' }}
                                        </span>
                                        <van-icon name="arrow" :size="14" />
                                    </div>
                                </template>
                            </van-field>
                        </template>
                    </template>
                    <van-field v-model="addEditData.regionRule" name="region" label="所在城市" input-align="right">
                        <template #input>
                            <div @click="onShowPopup('region')">
                                <span>
                                    {{ addEditData.region[0] ? `${addEditData.region.join(' ')}` : '所在城市' }}
                                </span>
                                <van-icon name="arrow" :size="14" />
                            </div>
                        </template>
                    </van-field>
                    <van-field v-model="addEditData.userMemberMobile" name="userMemberMobile" label="手机号"
                        input-align="right">
                    </van-field>
                    <van-field v-if="addEditData.isMainland" name="cardImgs" label="上传有效证件" class="line-break">
                        <template #input>
                            <div class="card-imgs">
                                <UploadImgs :fileStr.sync="addEditData.idCardFront" :limit="1" :width="200" :height="128"
                                    emptyTitle="上传正面" />
                                <UploadImgs :fileStr.sync="addEditData.idCardBack" :limit="1" :width="200" :height="128"
                                    emptyTitle="上传反面" />
                            </div>
                        </template>
                    </van-field>
                    <van-field v-model="addEditData.maritalStatus" name="婚姻状况" label="婚姻状况"
                        :rules="[{ required: true, message: '请选择婚姻状况' }]" class="line-break custom-radio">
                        <template #input>
                            <van-radio-group v-model="addEditData.maritalStatus" direction="horizontal">
                                <van-radio :name="item" v-for="(item) in healthData.maritalStatus" :key="item"
                                    :class="addEditData.maritalStatus === item ? 'radio-active' : ''">
                                    {{ item }}
                                </van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field name="maternityStatus" label="生育状况" class="line-break custom-radio">
                        <template #input>
                            <van-radio-group v-model="addEditData.maternityStatus" direction="horizontal">
                                <van-radio :name="item" v-for="(item) in healthData.maternityStatus" :key="item"
                                    :class="addEditData.maternityStatus === item ? 'radio-active' : ''">
                                    {{ item }}
                                </van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field v-model="addEditData.menstrualHistory" name="月经史" label="月经史"
                        :rules="[{ required: true, message: '请选择月经史' }]" class="line-break custom-radio"
                        v-if="addEditData.sex === 0">
                        <template #input>
                            <van-radio-group v-model="addEditData.menstrualHistory" direction="horizontal">
                                <van-radio :name="item" v-for="(item) in healthData.menstrualHistory" :key="item"
                                    :class="addEditData.menstrualHistory === item ? 'radio-active' : ''">
                                    {{ item }}
                                </van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field v-model="addEditData.diseaseHistory" name="diseaseHistory" label="疾病史" class="line-break">
                        <template #input>
                            <HealthCheckbox :select.sync="addEditData.diseaseHistory"
                                :options="healthData.diseaseHistory" />
                        </template>
                    </van-field>
                    <van-field v-model="addEditData.operation" name="operation" label="手术史或外伤史" class="line-break">
                        <template #input>
                            <HealthCheckbox :select.sync="addEditData.operation" :options="healthData.operation" />
                        </template>
                    </van-field>
                    <van-field v-model="addEditData.familyHistory" name="familyHistory" label="家族病史" class="line-break">
                        <template #input>
                            <HealthCheckbox :select.sync="addEditData.familyHistory" :options="healthData.familyHistory" />
                        </template>
                    </van-field>
                    <van-field v-model="addEditData.drugAllergy" name="drugAllergy" label="药物过敏" class="line-break">
                        <template #input>
                            <HealthCheckbox :select.sync="addEditData.drugAllergy" :options="healthData.drugAllergy" />
                        </template>
                    </van-field>
                    <van-field v-model="addEditData.foodAllergy" name="foodAllergy" label="食物/接触过敏" class="line-break">
                        <template #input>
                            <HealthCheckbox :select.sync="addEditData.foodAllergy" :options="healthData.foodAllergy" />
                        </template>
                    </van-field>
                    <!-- <van-field v-model="addEditData.menstrualHistory" name="menstrualHistory" label="月经史"
                        v-if="addEditData.sex === 0" class="line-break">
                        <template #input>
                            <HealthCheckbox :select.sync="addEditData.menstrualHistory" :options="[]" />
                        </template>
                    </van-field> -->
                    <van-field v-model="addEditData.auxiliaryExamination" name="auxiliaryExamination" label="辅助检查史"
                        class="line-break">
                        <template #input>
                            <HealthCheckbox :select.sync="addEditData.auxiliaryExamination" :options="[]" />
                        </template>
                    </van-field>
                </div>
                <div class="ask-info form-step-box" v-watermark>
                    <van-field name="askIllness" v-model="addEditData.askIllness" label="病情描述" type="textarea" rows="2"
                        maxlength="256" class="line-break">
                    </van-field>
                    <van-field v-if="addEditData.showTakeMedicineFeel" name="takeMedicineFeel"
                        v-model="addEditData.takeMedicineFeel" label="服药感受" type="textarea" rows="2" maxlength="256"
                        class="line-break">
                    </van-field>
                    <van-field name="病情相关图片/视频" label="病情相关图片/视频" class="line-break">
                        <template #input>
                            <div class="imgs-box">
                                <UploadImgs :fileStr.sync="addEditData.askImages" isUploadVideo />
                            </div>
                        </template>
                    </van-field>
                    <van-field name="questions" label="三因问卷" class="line-break">
                        <template #input>
                            <SelectThreeFactors :factorsOne.sync="addEditData.factorsOne"
                                :factorsTwo.sync="addEditData.factorsTwo" :factorsThree.sync="addEditData.factorsThree" />
                        </template>
                    </van-field>
                    <van-field name="threeConditionImages" label="舌诊照片" class="line-break">
                        <template #input>
                            <div class="upload-imgs">
                                <div v-for="(item, index) in [
                                    '眼睑',
                                    '眼睑',
                                    '舌苔',
                                    '舌下脉络'
                                ]" :key="index" class="upload-item">
                                    <div class="upload-title">
                                        <div>
                                            {{ { 0: '左眼', 1: '右眼' }[index] || '' }}
                                        </div>
                                        <div>{{ item }}</div>
                                    </div>
                                    <div class="upload-box">
                                        <UploadImgs :fileStr.sync="addEditData.threeConditionImages[index]" :limit="1" />
                                    </div>
                                </div>
                            </div>
                        </template>
                    </van-field>
                    <van-field name="diseaseTypeList" label="病种选择" class="line-break">
                        <template #input>
                            <SelectDisease :diseaseType.sync="addEditData.diseaseType"
                                :diseaseTypeList.sync="addEditData.diseaseTypeList" />
                        </template>
                    </van-field>
                    <van-field name="askDiseaseList" label="主诉症状" class="line-break">
                        <template #input>
                            <div class="base-button" @click="onShowPopup('symptomIds')">选择</div>
                            <div class="disease-box">
                                <div class="disease-item"
                                    v-for="(item, index) in getSymptomTreeChildren.filter(item => addEditData.symptomIds.includes(item.code))"
                                    :key="index">
                                    {{ item.name }}
                                </div>
                            </div>
                        </template>
                    </van-field>
                </div>
                <div class="form-step-box" v-watermark>
                    <van-field v-model="addEditData.remark" name="remark" label="备注" type="textarea" rows="2"
                        maxlength="256" class="line-break">
                    </van-field>
                </div>
            </van-form>
        </div>
        <div class="bottom-box safe-area-inset-bottom">
            <div class="bottom-container">
                <van-button @click="onStaging" class="button-box">暂存</van-button>
                <van-button type="info" @click="onSaveForm" class="button-box">提交信息</van-button>
            </div>
        </div>

        <SelectCityPopup :showSelectCityPopup.sync="popupState.showSelectCityPopup" :select.sync="addEditData.region" />

        <SelectDatePopup :showSelectDatePopup.sync="popupState.showSelectDatePopup" :select.sync="addEditData.birthday" />

        <ViewAskInfo :showViewAskInfoPopup.sync="popupState.showViewAskInfoPopup" :askInfo="addEditData" />

        <SelectSymptom :showSelectSymptom.sync="popupState.showSymptom" :symptomIds.sync="addEditData.symptomIds"
            :symptomData="getSymptomTree" :symptomChildren="getSymptomTreeChildren" />
    </div>
</template>
<script>
import { mapGetters } from 'vuex';


import SelectCityPopup from './components/selectCityPopup.vue';
import SelectDatePopup from './components/selectDatePopup.vue';
import HealthCheckbox from './components/healthCheckbox.vue';
import SelectThreeFactors from './components/selectThreeFactors.vue';
import SelectDisease from './components/selectDisease.vue';
import ViewAskInfo from './components/viewAskInfo.vue';
import SelectSymptom from '@/views/ask/components/selectSymptom.vue';

import { getPatientDetails, getAskDetail } from '@/api/index'
import { getAskCache, saveAskCache, removeAskCache, checkUserIdCard, getCheckFirstAsk } from '@/api/ask'
import { isIdCard, isTel } from '@/utils/validate'
import { timeFormat } from "@/utils/baseFormat";
import { formatteThreeConditionImages, analyzeIDCard } from '@/utils/utils'

import Vue from 'vue';
import { Dialog } from 'vant';
Vue.use(Dialog);
export default {
    name: 'CreateAsk',
    components: {
        HealthCheckbox,
        SelectCityPopup,
        SelectDatePopup,
        SelectThreeFactors,
        SelectDisease,
        ViewAskInfo,
        SelectSymptom
    },
    data() {
        return {
            addEditData: {
                isMainland: false,
                name: '', //姓名
                sex: '',// 性别
                idCard: '', //身份证
                idCardFront: '',
                idCardBack: '',
                birthday: '',// 出生日期
                userMemberMobile: '',// 手机
                region: [], //城市
                maritalStatus: '其他',//婚姻
                maternityStatus: '未生育',// 生育
                diseaseHistory: '暂无', //疾病史
                operation: '暂无', //手术史或外伤史
                familyHistory: '暂无', //家族病史
                drugAllergy: '暂无', // 药物过敏
                foodAllergy: '暂无', //食物/接触过敏
                menstrualHistory: '暂无', //月经史
                auxiliaryExamination: '暂无', //辅助检查史
                askImages: '',  // 相关病情图片
                threeConditionImages: ['', '', '', ''], // 舌诊
                diseaseType: null, // 主诉
                diseaseTypeList: '', // 病种
                //三因
                questions: [],
                factorsOne: [],
                factorsTwo: [],
                factorsThree: [],
                askIllness: '',
                takeMedicineFeel: '',
                showTakeMedicineFeel: false,
                symptomIds: []
            },
            popupState: {
                showSelectCityPopup: false,
                showSelectDatePopup: false,
                showViewAskInfoPopup: false,
                showSymptom: false
            }
        }
    },
    mounted() {
        this.init()
        this.$nextTick(() => {
            const element = document.getElementById("view");
            element.scrollIntoView();
        })
    },
    computed: {
        ...mapGetters({
            healthData: 'getHealthData',
            threeFactorsList: 'getThreeFactorsList',
            getSymptomTree: 'getSymptomTree',
            getSymptomTreeChildren: 'getSymptomTreeChildren'
        }),
        disabled() {
            return !!this.$route.query.userMemberId
        }
    },
    methods: {
        onClickLeft() {
            this.$router.back()
        },
        onIdCardInput(value) {
            if (!this.addEditData.isMainland) {
                if (isIdCard(value)) {
                    this.addEditData.sex = analyzeIDCard(value).sex
                } else {
                    this.addEditData.sex = ''
                    this.addEditData.menstrualHistory = '暂无'
                }
            }
            this.addEditData.idCard = isIdCard(value) ? value.toLocaleUpperCase() : value
        },
        onShowPopup(e) {
            switch (e) {
                case 'region':
                    this.popupState.showSelectCityPopup = true
                    break
                case 'birthday':
                    this.popupState.showSelectDatePopup = true
                    break
                case 'symptomIds':
                    this.popupState.showSymptom = true
                    break
                default:
                    break
            }
        },
        async onSaveForm() {
            if (!this.addEditData.name) {
                return this.$toast('请输入姓名');
            }
            if (!this.addEditData.userMemberMobile) {
                return this.$toast('请输入手机号')
            }
            if (!isTel(this.addEditData.userMemberMobile)) {
                return this.$toast('请输入正确的联系方式')
            }
            if (!this.addEditData.idCard) {
                return this.$toast(`请输入${this.addEditData.isMainland ? '有效证件号' : '身份证号'}`)
            }
            if (this.addEditData.isMainland) {
                if (!(typeof this.addEditData.sex === 'number')) {
                    return this.$toast('请选择性别');
                } else if (!this.addEditData.birthday) {
                    return this.$toast('请输入出生日期');
                } else if (!(this.addEditData.idCardFront && this.addEditData.idCardBack)) {
                    return this.$toast('请上传有效证件');
                }
            } else {
                if (!isIdCard(this.addEditData.idCard)) {
                    return this.$toast('请输入正确身份证号');
                }
            }
            if (!(this.addEditData.region.length === 2)) {
                return this.$toast('请选择所在城市');
            }
            if (!this.addEditData.diseaseHistory) {
                return this.$toast('请输入疾病史');
            }
            if (!this.addEditData.operation) {
                return this.$toast('请输入手术史或外伤史');
            }
            if (!this.addEditData.familyHistory) {
                return this.$toast('请输入家族病史');
            }
            if (!this.addEditData.drugAllergy) {
                return this.$toast('请输入药物过敏');
            }
            if (!this.addEditData.foodAllergy) {
                return this.$toast('请输入食物/接触过敏');
            }
            if (!this.addEditData.menstrualHistory) {
                return this.$toast('请输入月经史');
            }
            if (!this.addEditData.auxiliaryExamination) {
                return this.$toast('请输入辅助检查史');
            }
            if (!(this.addEditData.factorsOne.length > 0 && this.addEditData.factorsTwo.length > 0 && this.addEditData.factorsThree.length > 0)) {
                return this.$toast('请选择三因问卷');
            }
            if (this.addEditData.threeConditionImages.some((item) => !item)) {
                return this.$toast('请上传舌诊照片');
            }

            if (this.addEditData.threeConditionImages.some((item) => !item)) {
                return this.$toast('请上传舌诊照片');
            }

            // if (this.addEditData.symptomIds?.length === 0) {
            //     return this.$toast('请选择主诉症状');
            // }
            // 非中国大陆患者不需要校验
            if (this.addEditData.isMainland) {
               return this.popupState.showViewAskInfoPopup = true
            }
            const { data: { result } } = await checkUserIdCard({
                name: this.addEditData.name,
                idCard: this.addEditData.idCard
            })
            if (result !== '1') {
                // Dialog.alert({
                //     title: '提示',
                //     message: '输入的姓名和身份证号码不一致，请核对修改后再提交。',
                //     showCancelButton: true,
                //     cancelButtonText: '去核对',
                //     confirmButtonText: '无需修改',
                //     cancelButtonColor: '#666666',
                //     confirmButtonColor: '#0082ef'
                // }).then(() => {
                //     this.popupState.showViewAskInfoPopup = true
                //     console.log('确定')
                //     // on close
                // }).catch(() => {
                //     console.log('取消')
                // })
                return this.$toast('实名验证失败！');
            } else {
                this.popupState.showViewAskInfoPopup = true
            }
        },
        async onStaging() {
            try {
                const { assistantNo, userNo } = this.$route.query
                await saveAskCache({ refNo: assistantNo, userNo, desc: JSON.stringify(this.addEditData) })
            } catch (error) {
                console.log(error)
            }
        },
        async delStaging() {
            try {
                const { assistantNo, userNo } = this.$route.query
                await removeAskCache({ refNo: assistantNo, userNo, })
            } catch (error) {
                console.log(error)
            }
        },
        async init() {
            const { assistantNo, userMemberId, userNo, askType, askNo } = this.$route.query
            // 先判断有没有缓存 缓存优先
            try {
                const { data: askCache } = await getAskCache({ refNo: assistantNo, userNo })
                if (askCache) {
                    this.addEditData = JSON.parse(askCache)
                    await this.delStaging()
                } else {
                    // 新建
                    if (!userMemberId) return
                    const { data } = await getPatientDetails({ id: userMemberId })
                    const { userMemberHealth: { auxiliaryExaminatio,
                        menstrualHistory,
                        foodAllergy,
                        drugAllergy,
                        familyHistory,
                        operation,
                        diseaseHistory,
                        maternityStatus,
                        maritalStatus,
                        auxiliaryExamination
                    }, province, city, mobile, birthday, idCardFront, idCardBack, idCard, sex, name, isMainland } = data
                    this.addEditData = {
                        ...this.addEditData,
                        auxiliaryExaminatio: auxiliaryExaminatio || '暂无',
                        menstrualHistory: menstrualHistory || '暂无',
                        foodAllergy: foodAllergy || '暂无',
                        drugAllergy: drugAllergy || '暂无',
                        familyHistory: familyHistory || '暂无',
                        operation: operation || '暂无',
                        diseaseHistory: diseaseHistory || '暂无',
                        maternityStatus: maternityStatus || '未生育',
                        maritalStatus: maritalStatus || '未生育',
                        auxiliaryExamination: auxiliaryExamination || '暂无',
                        region: [province, city].filter(item => !!item),
                        userMemberMobile: mobile,
                        birthday: timeFormat(birthday, "yyyy-mm-dd"),
                        idCardBack: idCardBack,
                        idCardFront: idCardFront,
                        idCard: idCard,
                        sex: sex,
                        name: name,
                        isMainland: isMainland === 0
                    }
                    // 补方 直接带全部信息
                    if (Number(askType) === 13 && askNo) {
                        const { data: { askIllness, images, threeConditionImages, diseaseType, subDiseaseTypes, remark, userThreeConditionQuestionList, takeMedicineFeel, askDiseaseList } } = await getAskDetail({ askNo: askNo })
                        let feedbackData = {
                            feedback0: [],
                            feedback1: [],
                            feedback2: []
                        }
                            ; (userThreeConditionQuestionList || []).forEach((item) => {
                                this.threeFactorsList.forEach((Item) => {
                                    if (
                                        item.questionType === Item.questionType &&
                                        item.questionKewWord === Item.questionKewWord
                                    )
                                        feedbackData[`feedback${item.questionType}`].push(
                                            Item.questionSubject
                                        )
                                })
                            })
                        this.addEditData = {
                            ...this.addEditData,
                            takeMedicineFeel: takeMedicineFeel,
                            askIllness: askIllness,
                            askImages: images || '',
                            threeConditionImages: formatteThreeConditionImages(threeConditionImages),
                            diseaseType: diseaseType, // 主诉
                            diseaseTypeList: subDiseaseTypes, // 病种,
                            remark,
                            factorsOne:
                                feedbackData.feedback0.length === 0
                                    ? ['暂无以上症状']
                                    : feedbackData.feedback0,
                            factorsTwo:
                                feedbackData.feedback1.length === 0
                                    ? ['暂无以上症状']
                                    : feedbackData.feedback1,
                            factorsThree:
                                feedbackData.feedback2.length === 0
                                    ? ['暂无以上症状']
                                    : feedbackData.feedback2,
                            symptomIds: (askDiseaseList || []).map(item => item.code)
                        }
                    }
                }
                if (userMemberId) {
                    const { data: result } = await getCheckFirstAsk({ memberId: userMemberId })
                    this.addEditData.showTakeMedicineFeel = result.askNum !== 0
                }
            } catch (error) {
                console.log(error)
            }
        },
    },
}
</script>
<style lang="scss" scoped>
:deep(.disease-box) {
    display: flex;
    flex-wrap: wrap;
    line-height: normal;

    .disease-item {
        padding: 4px 9px;
        background: #eff3fb;
        border: 1px solid #0082ef;
        color: #0082ef;
        border-radius: 4px;
        margin-right: 10px;
        margin-top: 10px;
    }
}

.base-button {
    background: #0082ef;
    border-radius: 4px;
    padding: 5px 18px;
    color: #fff;
    cursor: pointer;
    text-align: center;
    line-height: normal;
    position: absolute;
    top: -30px;
    right: 0;
}

.create-ask-box {
    padding-bottom: 100px;

    .bottom-box {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        border-radius: 0px 0px 0px 0px;
        z-index: 10;
        background: #ffffff;

        .bottom-container {
            height: 84px;
            background: #ffffff;
            box-sizing: border-box;
            padding: 16px 25px;
            display: flex;

            .button-box {
                font-size: 18px;
                border: none;
                border-radius: 8px;
                flex: 1.8;

                &:nth-child(1) {
                    flex: 1;
                    background: #e6f0fa;
                    margin-right: 30px;
                    color: #1989fa;
                }
            }
        }
    }

    :deep(.van-nav-bar) {

        .van-nav-bar__left,
        .van-icon {
            font-size: 20px;
        }
    }

    .form-box {
        box-sizing: border-box;

        .van-field,
        .van-cell {
            background-color: transparent;
        }

        :deep(.van-field) {
            .van-field__error-message {
                text-align: right;
            }

            .van-cell__title {
                color: #333;
            }
        }

        :deep(.line-break) {
            flex-direction: column;
            position: relative;

            .van-field__label {
                width: auto !important;
            }

            .van-field__control {
                min-height: auto;
            }

            textarea {
                padding: 5px;
                position: relative;
                border: 1px solid #ccc;
                border-radius: 4px;

                &::after {
                    position: absolute;
                    box-sizing: border-box;
                    content: ' ';
                    pointer-events: none;
                    top: -50%;
                    right: -50%;
                    bottom: -50%;
                    left: -50%;
                    border: 0 solid #ebedf0;
                    transform: scale(0.5);
                    border-radius: 4px;
                }
            }
        }

        :deep(.custom-radio) {
            .van-radio-group {
                padding: 10px 0;

                .van-radio {
                    padding: 4px 14px;
                    border-radius: 14px;
                    border: 1px solid #DDDDDD;
                    background: #fff;

                    .van-icon {
                        display: none;
                    }

                    .van-radio__label {
                        margin-left: 0;
                        color: #888888;
                    }
                }

            }

            .radio-active {
                border: 1px solid #0082ef !important;
                background: #eff3fb !important;

                .van-radio__label {
                    color: #0082ef !important;
                }
            }

        }

        .form-step-box {
            background: #fff;

            +.form-step-box {
                margin-top: 15px;
            }


        }

        .user-info-box {

            .user-title {
                padding: 10px 16px;
                font-size: 18px;
                color: #333;
                font-weight: bold;
            }

            .card-imgs {
                padding: 10px 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
            }
        }

        .ask-info {
            .imgs-box {
                padding: 15px 0;
            }

            .upload-imgs {
                width: 100%;
                display: flex;
                padding: 15px 0;
                flex-wrap: wrap;
                justify-content: space-between;

                .upload-item {
                    overflow: hidden;
                    width: 100px;

                    .upload-title {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }
    }
}
</style>